import React from "react";
import { Box, Typography, Button, Zoom, Avatar, alpha, Chip } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Home as HomeIcon,
  HourglassEmpty as PendingIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";

const SuccessStep = ({ primaryColor, companyName }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      py={6}
    >
      {/* 1. Animated Success Icon */}
      <Zoom in={true} style={{ transitionDelay: "300ms" }}>
        <Box position="relative" mb={4}>
          {/* Outer Ring (Pulse Effect) */}
          <Box
            sx={{
              position: "absolute",
              top: -20,
              left: -20,
              width: 140,
              height: 140,
              borderRadius: "50%",
              bgcolor: alpha(primaryColor, 0.1),
              animation: "pulse 2s infinite",
              zIndex: 0,
              "@keyframes pulse": {
                "0%": { transform: "scale(0.95)", opacity: 0.7 },
                "70%": { transform: "scale(1.1)", opacity: 0 },
                "100%": { transform: "scale(0.95)", opacity: 0 },
              },
            }}
          />

          {/* Main Icon */}
          <Avatar
            sx={{
              width: 100,
              height: 100,
              bgcolor: primaryColor,
              boxShadow: `0 8px 24px ${alpha(primaryColor, 0.4)}`,
              zIndex: 1,
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 60, color: "#fff" }} />
          </Avatar>
        </Box>
      </Zoom>

      {/* 2. Headline */}
      <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ color: "#344767" }}>
        Application Submitted!
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mb: 4 }}>
        Thank you for your interest in {companyName || "our company"}. We have received your details
        and answers successfully.
      </Typography>

      {/* 3. Status Card */}
      <Box
        sx={{
          bgcolor: "grey.50",
          border: "1px solid",
          borderColor: "grey.200",
          borderRadius: 2,
          p: 3,
          mb: 5,
          width: "100%",
          maxWidth: 400,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box textAlign="left">
          <Typography
            variant="caption"
            color="text.secondary"
            textTransform="uppercase"
            fontWeight="bold"
          >
            Current Status
          </Typography>
          <Typography variant="h6" fontWeight="medium" color="text.primary">
            Pending Review
          </Typography>
        </Box>
        <Chip
          icon={<PendingIcon sx={{ fontSize: "16px !important" }} />}
          label="In Progress"
          color="warning"
          size="small"
          sx={{ fontWeight: "bold", bgcolor: "#fff8e1", color: "#ff8f00" }}
        />
      </Box>
    </Box>
  );
};

SuccessStep.propTypes = {
  primaryColor: PropTypes.string,
  companyName: PropTypes.string,
};

export default SuccessStep;
